import { compose, lifecycle } from "recompact"
import { contextConsumer } from "./index"

const enhancer = compose(
  contextConsumer,
  lifecycle({
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      this.props.overlay.enable(this.props)
    },
    componentWillUnmount() {
      this.props.overlay.disable()
    },
  }),
)

export default enhancer(() => null)
